<template>
  <Card class="page-item clickable" v-bind:class="selectedPageBindings">
    <div class="row" v-on:click="selectPage">
      <div class="col-md-8 push-md-4">
        <div class="page-summary-container">
          <div class="page-summary">
            <p class="typography--body-3 typography--color-secondary">
              <strong>{{ pageType }} {{ index + 1 }}</strong>
            </p>

            <div class="page-content-container"
                 v-bind:class="classBindings">
              <div class="page-image-summary float-left" v-if="hasImage" v-bind:style="{ 'background-image': firstImageSrc }"></div>

              <div class="page-audio-summary" v-if="hasAudio">
                <img src="/static/images/icon-audio.svg" class="align-middle" />
                <span class="align-middle typography--body-3">{{ firstAudioDuration | duration }}</span>
              </div>

              <div class="page-video-summary" v-if="hasVideo || hasEmbededVideo">
                <img src="/static/images/icon-video.svg" class="align-middle" />
                <span class="align-middle typography--body-3">{{ firstVideoDuration | duration }}</span>
              </div>

              <div class="typography--body-2 typography--pre-line page-content"
                   v-html="page.content">
              </div>
            </div>

          </div>
        </div>
      </div>

      <div class="col-md-4 pull-md-8">
        <div class="card-top-info">
          <h4 class="typography--title page-card-title">
            {{ page.card_title }}
          </h4>

          <small class="typography--caption">
            {{ getGradeLabel(page) }}
            {{ getSubjectLabel(page) }}
            <span v-if="page.chapter_name">
              {{ page.chapter_name }}
            </span>
            <span v-else>
              {{ getCoreConceptLabel(coreConcepts[page.core_concept_id]) }}
            </span>
          </small>
        </div>

        <div class="card-bottom-info">
          <small class="typography--caption typography--color-secondary mb-1">
            <!-- TODO replace with real share count -->
            <span v-if="page.card_assigned_count">| {{ $t('common.card.share_count', { cnt: page.card_assigned_count }) }}</span>
          </small>
        </div>
      </div>
    </div>

    <div class="card-action">
      <div class="card-action-btn text-right">
        <a class="typography--body-3" v-on:click="openCardPreview">
          {{ $t('common.preview') }}
        </a>
      </div>
    </div>
  </Card>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import labels from '@/mixins/labels';

  export default {
    name: 'page-item',

    props: [
      'index',
      'page',
    ],

    mixins: [
      labels,
    ],

    computed: {
      ...mapGetters([
        'selectedPageIds',
        'coreConcepts',
        'subjectMap',
        'gradeMap',
      ]),

      isSelectedPage() {
        return this.selectedPageIds.indexOf(this.page.id) !== -1;
      },

      selectedPageBindings() {
        return {
          'selected-page': this.isSelectedPage,
        };
      },

      pageType() {
        if (this.page && this.page.is_quiz) {
          return this.$t('page_editor.question.title');
        }

        return this.$t('page_editor.non_quiz.title');
      },

      hasImage() {
        return this.page.image_count > 0 && this.page.images.length > 0;
      },

      hasAudio() {
        return this.page.audio_count > 0 && this.page.audios.length > 0;
      },

      hasVideo() {
        return this.page.video_count > 0 && this.page.videos && this.page.videos.length > 0;
      },

      hasEmbededVideo() {
        return this.page.content.match(/<iframe/g) || (this.page.description || '').match(/<iframe/g);
      },

      classBindings() {
        return {
          'has-image': this.hasImage,
          'has-audio': this.hasAudio,
          'has-video': this.hasVideo || this.hasEmbededVideo,
        };
      },

      firstImageSrc() {
        if (this.hasImage) {
          const imageUrl = this.page.images[0].image_url ||
            this.page.images[0].small_url ||
            this.page.images[0].medium_url ||
            this.page.images[0].original_url;

          return `url('${imageUrl}')`;
        }

        return '';
      },

      firstAudioDuration() {
        if (this.hasAudio) {
          return this.page.audios[0].duration;
        }

        return 0;
      },

      firstVideoDuration() {
        if (this.hasVideo) {
          return this.page.videos[0].duration;
        }

        return 0;
      },
    },

    methods: {
      ...mapActions([
        'setSelectedPreviewPageIndex',
        'setSelectedPreviewCard',
        'removeSelectedPage',
        'setIsPagePreview',
        'addSelectedPage',
      ]),

      selectPage() {
        if (this.isSelectedPage) {
          return this.removeSelectedPage(this.page.id);
        }

        return this.addSelectedPage(this.page);
      },

      openCardPreview() {
        const tempCard = {
          title: this.page.card_title,
          pages: [this.page],
        };

        this.setSelectedPreviewCard(tempCard)
          .then(() => (
            this.setSelectedPreviewPageIndex(0)
          ))
          .then(() => (
            this.setIsPagePreview(true)
          ))
          .then(() => {
            this.$root.$emit('show::modal', 'card-preview-modal');
          });
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/PageItem.vue